<template>
  <section class="flex align-middle justify-center sm:py-40">
    <div class="flex flex-col">
      <a class="link--primary mb-16" :href="redirectTo">
        <div class="inline-block md:pl-0 mt-4"><BackIcon /></div>
        <p class="inline-block ml-8">Pricing</p>
      </a>
      <Card class="w-full max-w-448 p-24">
        <form @submit.prevent="submit">
          <h1 class="text-h1 mb-16">Check your eligibility</h1>
          <fieldset>
            <legend class="pb-16 text-body text-grey-body">
              If your company is found, Sittercity Premium may be included in your corporate benefits
            </legend>
            <CorporateClientComboBox :error-text="errorText" @selected-client="selectedClient" />
          </fieldset>
          <Button class="w-full mt-16" variant="primary" value="Continue" size="medium" type="submit" />
        </form>
      </Card>
    </div>
  </section>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import BackIcon from '@/icons/BackIcon.vue';
import { sendSegmentEvent } from '@/lib/segment';
import CorporateClientComboBox from '../../components/CorporateClientComboBox.vue';

export default {
  name: 'CheckEligibility',
  components: {
    Button,
    Card,
    BackIcon,
    CorporateClientComboBox,
  },
  props: {
    redirectTo: { type: String, default: '' },
  },
  data(): any {
    return {
      employerNameInput: '',
      selectedCompanySlug: '',
      selectedBhClientId: '',
    };
  },
  computed: {
    errorText(): string {
      return 'Enter a valid name';
    },
  },
  methods: {
    selectedClient({ slug, name, bhClientId }) {
      this.employerNameInput = name;
      this.selectedCompanySlug = slug;
      this.selectedBhClientId = bhClientId;
    },
    submit() {
      sendSegmentEvent('CorporateBenefit_SearchedEmployer', {
        employerSlugEntered: this.selectedCompanySlug,
        employerNameInput: this.employerNameInput,
      });
      if (this.selectedBhClientId !== '') {
        // success
        // go to the next page - request upgrade
        this.$emit('advanceStep', {
          employerNameInput: this.employerNameInput,
          slug: this.selectedCompanySlug,
          bhClientId: this.selectedBhClientId,
        });
      } else {
        // otherwise redirect to pricing page the user was already at & track segment event
        sendSegmentEvent('Invalid Employer Entered', {
          employerEntered: this.employerNameInput,
        });
        const url = new URL(window.location.origin + this.redirectTo);
        url.searchParams.append('error', 'company_not_found');
        window.location.href = url.toString();
      }
    },
  },
};
</script>
